import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import HeaderComponent from "../../components/Header";
import { constants } from "../../Constants";
import Footer from "../../components/Footer/footer";
import Swal from "sweetalert2";
import './familyMemberList.css';
import { familyMemberAction } from "../../store/actions/familyMember.actions";
import Loading from '../../components/Loading/Loading';
import { familyMemberService } from "../../services/familyMember.service";
import FamilyMember from "../../components/FamilyMemberList";

class ViewFamilyMember extends Component {
    constructor(props) {
        super(props);
        this.state = {
            members: [],
        };
    }
    componentDidMount() {
        this.props.getFamilyMembers();
    }

    componentDidUpdate(prevProps) {
        // Check if new props have arrived, and update the state accordingly
        if (prevProps.familyMembers.members !== this.props.familyMembers.members) {
            this.setState({
                members: this.props.familyMembers.members,
            });
        }
    }

    deleteFamilyMember = async (member) => {
        if (!member) {
            Swal.fire('Error', constants.FMAILY_MEMBER_NOT_FOUND_TXT, 'error');
            return;
        }
        const { id } = member;
        Swal.fire({
            title: constants.DELETE_CONFORM_HEADER_TXT,
            text: `${constants.DELETE_CONFRIM_TXT_ONE} “${member.user.full_name}” ${constants.DELETE_CONFRIM_TXT_TWO}`,
            type: constants.QUESTION_TYPE_TXT,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonColor: constants.CONFIRM_BUTTON_COLOUR,
            cancelButtonColor: constants.CANCEL_BUTTON_COLOUR,
            cancelButtonText: constants.NO_TXT,
            confirmButtonText: constants.YES_TXT,
        }).then(async (result) => {
            if (result.value) {
                try {
                    await familyMemberService.deleteFamilyMember(id);
                    this.setState((prevState) => ({
                        members: prevState.members.filter((member) => member.id !== id),
                    }));
                    Swal.fire({
                        titleText: constants.SAAYA_HEALTH_TXT,
                        text: constants.FMAILY_MEMBER_DELETE_SUCCESS_TXT,
                        icon: '',
                        confirmButtonText:constants.OK_TXT
                    });
                }
                catch (error) {
                    const errorMessage = error.error || constants.FMAILY_MEMBER_DEFAULT_DELETE_ERROR_TXT;
                    Swal.fire('Error', errorMessage, 'error');
                }
            }
        });
    };

    addFamilyMember = () => {
        const { history, location } = this.props;
        // Check if the current route is the same as the target route
        if (location.pathname !== '/family_member/add') {
            history.push('/family_member/add');
        }
    }

    render() {
        const { loading } = this.props.familyMembers;
        const { members } = this.state;

        if (loading) {
            return <Loading />;
        }

        return (
            <div className="family-member-container sh-layout hoffen-block">
                <HeaderComponent />
                <div className="sh-patient-note-comp sh-gnrl-width">
                    {/* Welcome Note */}
                    <div className="sh-gnrl-welcome-note">
                        <h2 className="sh-gnrl-welcome">{constants.VIEW_FMAILY_MEMBER_TXT.toUpperCase()}</h2>
                    </div>
                    {/*  Family Member Div */}
                    <div className="sh-gnrl-container familyMember-container">
                        {Array.isArray(members) && members.length > 0 ? (
                            <div className="sh-gnrl-container familyMember-table-container">
                                {Array.isArray(members) && members.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table borderless family-member-table"> 
                                            <thead className="text-center">
                                                <tr>
                                                    <th>
                                                        <span className="sh-gnrl-cchc-main-head">
                                                            {constants.FMAILY_MEMBER_NAME_TXT}
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span className="sh-gnrl-cchc-main-head">
                                                            {constants.FMAILY_MEMBER_RELATION_TXT}
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span className="sh-gnrl-cchc-main-head">
                                                            {constants.FMAILY_MEMBER_EMAIL_TXT}
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span className="sh-gnrl-cchc-main-head">
                                                            <i className="fa fa-bars"></i>
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-row-text">
                                                {members.map((member, index) => (
                                                    <FamilyMember
                                                        key={index} 
                                                        member={member}
                                                        index={index}
                                                        deleteFamilyMember={this.deleteFamilyMember}
                                                    />
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <h3 className="sh-gnrl-empty-note">{constants.EMPTY_FMAILY_MEMBER_TXT}</h3>
                                )}
                            </div>

                        ) : (
                            <h3 className="sh-gnrl-empty-note">{constants.EMPTY_FMAILY_MEMBER_TXT}</h3>
                        )}
                    </div>
                    <div className="text-center sh-gnrl-row my-3">
                        <div className="add-member-btn">
                            <button
                                id='add-family-member-btn'
                                className="sh-gnrl-btn sh-rgstr-btn"
                                onClick={this.addFamilyMember}
                            >
                                {constants.ADD_MEMBER_TXT}
                            </button>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { auth, familyMembers } = state;
    const { user } = auth;
    return {
        user,
        familyMembers
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFamilyMembers: () => {
            dispatch(familyMemberAction.getFamilyMembers());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewFamilyMember));



// WEBPACK FOOTER //
// ./src/screens/FamilyMemberList/index.js